import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEyeSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEyeSparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M11.998 4C16.1398 4.00003 20.1608 6.64069 22.6699 11.665L22.8369 12L22.6699 12.335C20.1608 17.3593 16.1398 20 11.998 20C7.85646 19.9998 3.8362 17.3591 1.32715 12.335L1.16016 12L1.32715 11.665C3.8362 6.64086 7.85646 4.00015 11.998 4ZM10.5996 10.5996L8 11.5996V12.4004L10.5996 13.4004L11.5996 16H12.4004L13.4004 13.4004L16 12.4004V11.5996L13.4004 10.5996L12.4004 8H11.5996L10.5996 10.5996Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEyeSparkle;
